import { ModuleNames } from './userConstants';

// Module IDs for each module in the system
export const ModuleIds = {
  [ModuleNames.ENO1_SAMPLING]: 16,
  [ModuleNames.E53_SAMPLING]: 17,
  [ModuleNames.SAMPLING_PLANNING]: 18,
  [ModuleNames.E55_WEIGHTS]: 19,
  [ModuleNames.E09_IBRS]: 20,
  [ModuleNames.IPC_TD_ACCOUNTING]: 21,
  [ModuleNames.TD_ACCOUNTING]: 22,
} as const;

// Permission IDs for each permission in each module
export const PermissionIds = {
  [ModuleNames.ENO1_SAMPLING]: {
    'Access to the eNO1 module': 73,
    'eNO1 View Samples': 74,
    'eNO1 Edit Samples': 75,
    'Delete eNO1 Files': 76,
    'eNO1 Upload': 77,
    'eNO1 Status': 78,
    'NO2 Report': 79,
    'NO3 Report': 80,
    'NO3 Signed Forms': 81,
    'Accuracy Report': 82,
    'e55 Comparison': 83,
    'eNO1 Playground': 84,
  },
  [ModuleNames.E53_SAMPLING]: {
    'Access to the e53 sampling module': 85,
    'e53 View Samples': 86,
    'e53 Edit Samples': 87,
    'Delete e53 files': 88,
    'e53 Upload': 89,
    'View e53 status': 90,
    'CN54 Report': 91,
  },
  [ModuleNames.SAMPLING_PLANNING]: {
    'Access to the Sampling Planning module': 92,
  },
  [ModuleNames.E55_WEIGHTS]: {
    'View Despatches': 93,
    'Edit Despatches': 94,
    'Delete e55 Files': 95,
    'e55 Upload': 96,
    'e55 Status': 97,
    'CN56 Report': 98,
    'e55 items-kg report': 99,
  },
  [ModuleNames.E09_IBRS]: {
    'View Despatches': 100,
    'Edit Despatches': 101,
    'Delete e09 Files': 102,
    'e09 Upload': 103,
    'e09 Status': 104,
    'CN10 Report': 105,
    'CN19 Report': 106,
  },
  [ModuleNames.IPC_TD_ACCOUNTING]: {
    'Access to IPC Accounting module': 107,
  },
  [ModuleNames.TD_ACCOUNTING]: {
    'Access to the UPU TD Accounting module': 109,
  },
} as const;

// Default module structure with all modules and their permissions
export const DefaultModules = [
  {
    id: ModuleIds[ModuleNames.ENO1_SAMPLING],
    name: 'eNO1 Sampling',
    url: '/eno1',
    enabled: false,
    permissions: [
      {
        id: PermissionIds[ModuleNames.ENO1_SAMPLING]['Access to the eNO1 module'],
        name: 'Access to the eNO1 module',
        url: '/eno1',
        enabled: false
      },
      {
        id: PermissionIds[ModuleNames.ENO1_SAMPLING]['eNO1 View Samples'],
        name: 'eNO1 View Samples',
        url: '/eno1/samples',
        enabled: false
      },
      {
        id: PermissionIds[ModuleNames.ENO1_SAMPLING]['eNO1 Edit Samples'],
        name: 'eNO1 Edit Samples',
        url: '/eno1/samples/edit',
        enabled: false
      },
      {
        id: PermissionIds[ModuleNames.ENO1_SAMPLING]['Delete eNO1 Files'],
        name: 'Delete eNO1 Files',
        url: '/eno1/files/delete',
        enabled: false
      },
      {
        id: PermissionIds[ModuleNames.ENO1_SAMPLING]['eNO1 Upload'],
        name: 'eNO1 Upload',
        url: '/eno1/upload',
        enabled: false
      },
      {
        id: PermissionIds[ModuleNames.ENO1_SAMPLING]['eNO1 Status'],
        name: 'eNO1 Status',
        url: '/eno1/status',
        enabled: false
      },
      {
        id: PermissionIds[ModuleNames.ENO1_SAMPLING]['NO2 Report'],
        name: 'NO2 Report',
        url: '/eno1/reports/no2',
        enabled: false
      },
      {
        id: PermissionIds[ModuleNames.ENO1_SAMPLING]['NO3 Report'],
        name: 'NO3 Report',
        url: '/eno1/reports/no3',
        enabled: false
      },
      {
        id: PermissionIds[ModuleNames.ENO1_SAMPLING]['NO3 Signed Forms'],
        name: 'NO3 Signed Forms',
        url: '/eno1/reports/no3/signed',
        enabled: false
      },
      {
        id: PermissionIds[ModuleNames.ENO1_SAMPLING]['Accuracy Report'],
        name: 'Accuracy Report',
        url: '/eno1/reports/accuracy',
        enabled: false
      },
      {
        id: PermissionIds[ModuleNames.ENO1_SAMPLING]['e55 Comparison'],
        name: 'e55 Comparison',
        url: '/eno1/reports/e55-comparison',
        enabled: false
      },
      {
        id: PermissionIds[ModuleNames.ENO1_SAMPLING]['eNO1 Playground'],
        name: 'eNO1 Playground',
        url: '/eno1/playground',
        enabled: false
      }
    ]
  },
  {
    id: ModuleIds[ModuleNames.E53_SAMPLING],
    name: 'e53 Sampling',
    url: '/e53',
    enabled: false,
    permissions: [
      {
        id: PermissionIds[ModuleNames.E53_SAMPLING]['Access to the e53 sampling module'],
        name: 'Access to the e53 sampling module',
        url: '/e53',
        enabled: false
      },
      {
        id: PermissionIds[ModuleNames.E53_SAMPLING]['e53 View Samples'],
        name: 'e53 View Samples',
        url: '/e53/samples',
        enabled: false
      },
      {
        id: PermissionIds[ModuleNames.E53_SAMPLING]['e53 Edit Samples'],
        name: 'e53 Edit Samples',
        url: '/e53/samples/edit',
        enabled: false
      },
      {
        id: PermissionIds[ModuleNames.E53_SAMPLING]['Delete e53 files'],
        name: 'Delete e53 files',
        url: '/e53/files/delete',
        enabled: false
      },
      {
        id: PermissionIds[ModuleNames.E53_SAMPLING]['e53 Upload'],
        name: 'e53 Upload',
        url: '/e53/upload',
        enabled: false
      },
      {
        id: PermissionIds[ModuleNames.E53_SAMPLING]['View e53 status'],
        name: 'View e53 status',
        url: '/e53/status',
        enabled: false
      },
      {
        id: PermissionIds[ModuleNames.E53_SAMPLING]['CN54 Report'],
        name: 'CN54 Report',
        url: '/e53/reports/cn54',
        enabled: false
      }
    ]
  },
  {
    id: ModuleIds[ModuleNames.SAMPLING_PLANNING],
    name: 'Sampling Planning',
    url: '/sampling-planning',
    enabled: false,
    permissions: [
      {
        id: PermissionIds[ModuleNames.SAMPLING_PLANNING]['Access to the Sampling Planning module'],
        name: 'Access to the Sampling Planning module',
        url: '/sampling-planning',
        enabled: false
      }
    ]
  },
  {
    id: ModuleIds[ModuleNames.E55_WEIGHTS],
    name: 'e55 Weights',
    url: '/e55',
    enabled: false,
    permissions: [
      {
        id: PermissionIds[ModuleNames.E55_WEIGHTS]['View Despatches'],
        name: 'View Despatches',
        url: '/e55/despatches',
        enabled: false
      },
      {
        id: PermissionIds[ModuleNames.E55_WEIGHTS]['Edit Despatches'],
        name: 'Edit Despatches',
        url: '/e55/despatches/edit',
        enabled: false
      },
      {
        id: PermissionIds[ModuleNames.E55_WEIGHTS]['Delete e55 Files'],
        name: 'Delete e55 Files',
        url: '/e55/files/delete',
        enabled: false
      },
      {
        id: PermissionIds[ModuleNames.E55_WEIGHTS]['e55 Upload'],
        name: 'e55 Upload',
        url: '/e55/upload',
        enabled: false
      },
      {
        id: PermissionIds[ModuleNames.E55_WEIGHTS]['e55 Status'],
        name: 'e55 Status',
        url: '/e55/status',
        enabled: false
      },
      {
        id: PermissionIds[ModuleNames.E55_WEIGHTS]['CN56 Report'],
        name: 'CN56 Report',
        url: '/e55/reports/cn56',
        enabled: false
      },
      {
        id: PermissionIds[ModuleNames.E55_WEIGHTS]['e55 items-kg report'],
        name: 'e55 items-kg report',
        url: '/e55/reports/items-kg',
        enabled: false
      }
    ]
  },
  {
    id: ModuleIds[ModuleNames.E09_IBRS],
    name: 'e09 IBRS',
    url: '/e09',
    enabled: false,
    permissions: [
      {
        id: PermissionIds[ModuleNames.E09_IBRS]['View Despatches'],
        name: 'View Despatches',
        url: '/e09/despatches',
        enabled: false
      },
      {
        id: PermissionIds[ModuleNames.E09_IBRS]['Edit Despatches'],
        name: 'Edit Despatches',
        url: '/e09/despatches/edit',
        enabled: false
      },
      {
        id: PermissionIds[ModuleNames.E09_IBRS]['Delete e09 Files'],
        name: 'Delete e09 Files',
        url: '/e09/files/delete',
        enabled: false
      },
      {
        id: PermissionIds[ModuleNames.E09_IBRS]['e09 Upload'],
        name: 'e09 Upload',
        url: '/e09/upload',
        enabled: false
      },
      {
        id: PermissionIds[ModuleNames.E09_IBRS]['e09 Status'],
        name: 'e09 Status',
        url: '/e09/status',
        enabled: false
      },
      {
        id: PermissionIds[ModuleNames.E09_IBRS]['CN10 Report'],
        name: 'CN10 Report',
        url: '/e09/reports/cn10',
        enabled: false
      },
      {
        id: PermissionIds[ModuleNames.E09_IBRS]['CN19 Report'],
        name: 'CN19 Report',
        url: '/e09/reports/cn19',
        enabled: false
      }
    ]
  },
  {
    id: ModuleIds[ModuleNames.IPC_TD_ACCOUNTING],
    name: 'IPC TD Accounting',
    url: '/ipc-td-accounting',
    enabled: false,
    permissions: [
      {
        id: PermissionIds[ModuleNames.IPC_TD_ACCOUNTING]['Access to IPC Accounting module'],
        name: 'Access to IPC Accounting module',
        url: '/ipc-td-accounting',
        enabled: false
      }
    ]
  },
  {
    id: ModuleIds[ModuleNames.TD_ACCOUNTING],
    name: 'UPU TD Accounting',
    url: '/td-accounting',
    enabled: false,
    permissions: [
      {
        id: PermissionIds[ModuleNames.TD_ACCOUNTING]['Access to the UPU TD Accounting module'],
        name: 'Access to the UPU TD Accounting module',
        url: '/td-accounting',
        enabled: false
      }
    ]
  }
];

export default {
  ModuleIds,
  PermissionIds,
  DefaultModules
}; 